<template>
    <header class="header navbar navbar-dark flex-md-nowrap">
        <div class="header__container container-fluid">
            <a class="header__hlogo hlogo" title="Digital services intellectual software development">
                <img src="/images/logo-white-rus.svg" alt="">
            </a>
        </div>
    </header>
</template>
<script>

export default {
    name: 'HeaderComponentDevicesInventory'
};
</script>
